var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input",
    _vm._b(
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.context.model,
            expression: "context.model",
          },
        ],
        attrs: {
          readonly: "",
          "input-class": _vm.context.attributes.class,
          "data-type": _vm.context.type,
          type: "password",
        },
        domProps: { value: _vm.context.model },
        on: {
          focus: _vm.onFocus,
          blur: _vm.onBlur,
          touchstart: _vm.onTouchStart,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.context, "model", $event.target.value)
          },
        },
      },
      "input",
      _vm.context.attributes,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }